import { webApiClient } from 'Shared/web_api_client';

export type ModalModuleContent<Data = unknown> = {
   html: string;
   css: string[];
   js: string[];
   data: Data;
};

/**
 * A module modal's content (ModalModulesApi). The photo dialogs take
 * `imageid`, `imageType` and `accepts`.
 */
export async function loadModalModule<Data = unknown>(
   name: string,
   options: Record<string, unknown> = {}
): Promise<ModalModuleContent<Data>> {
   const params = new URLSearchParams();
   for (const [key, value] of Object.entries(options)) {
      if (value != null) {
         params.set(key, String(value));
      }
   }
   const search = params.toString();
   const query = search ? `?${search}` : '';
   const client = await webApiClient();
   return client.get<ModalModuleContent<Data>>(
      `modal-modules/${encodeURIComponent(name)}${query}`,
      { statName: 'modal-module' }
   );
}
